import { observable, action, reaction } from 'mobx';
import { toastr } from 'react-redux-toastr';
import format from 'date-fns/format';
import controller from './carmenController';
import { officeStore } from '../../../partners/store/officeStore';
import APPConf from '../../../../lib/config/common';

export const carmenStore = observable({
  availableDates: [],
  availableTimes: [],
  availableTimeOfficeId: '', // id офиса, данные по которому находятся в availableTimes
  availableTimeDate: null, // дата, по которой в availableTimes находятся данные
  error: null,
});

export const carmenActions = {
  getOfficeAvailableDates: action(async data => {
    const response = await controller.getOfficeAvailableDates(data);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
    carmenStore.availableDates = response.data?.freeDates || [];
  }),
  getOfficeAvailableTime: action(async data => {
    if ((carmenStore.availableTimeOfficeId !== data.officeId) || (carmenStore.availableTimeDate !== format(data.date, 'yyyy-MM-dd'))) {
      carmenStore.availableTimeOfficeId = data.officeId;
      carmenStore.availableTimeDate = format(data.date, 'yyyy-MM-dd');
      const response = await controller.getOfficeAvailableTime(data);
      if (response.errorData) {
        officeStore.error = response.errorData;
      }
      carmenStore.availableTimes = response.data?.freeSlots || [];
    }
  }),
  clearAvailableTimeAndDate: action(async () => {
    carmenStore.availableDates = [];
    carmenStore.availableTimes = [];
    carmenStore.availableTimeOfficeId = null;
    carmenStore.availableTimeDate = null;
  }),
};

reaction(() => carmenStore.error, () => {
  if (carmenStore.error) {
    toastr.error(APPConf.errorHdr, carmenStore.error);
  }
});
